"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationReview',
  data: function data() {
    return {
      tab: 'review',
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        status: '',
        recoveryStatus: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    recoveryText: function recoveryText(value) {
      return {
        not_required: '无需',
        pending: '待挽回',
        recovering: '挽回中',
        recovered: '已挽回',
        failed: '未挽回'
      }[value] || value;
    },
    complaintText: function complaintText(value) {
      return {
        submitted: '已提交',
        accepted: '已受理',
        processing: '处理中',
        pending_forgiveness: '待谅解',
        forgiven: '已谅解',
        resolved: '已处理',
        closed: '已关闭'
      }[value] || value;
    },
    actionText: function actionText(value) {
      return {
        reply: '回复',
        recover: '已挽回',
        fail_recover: '未挽回',
        hide: '屏蔽',
        withdraw: '撤回',
        accept: '受理',
        process: '处理',
        resolve: '办结',
        forgive: '谅解',
        close: '关闭'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      var api = this.tab === 'review' ? _decoration.decorationReviewListApi : _decoration.decorationComplaintListApi;
      api(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.loadCurrent();
    },
    runReview: function runReview(row, action) {
      var _this2 = this;
      var payload = {
        action: action
      };
      var ask = ['reply', 'recover', 'fail_recover'].includes(action);
      var exec = function exec(text) {
        if (action === 'reply') payload.replyContent = text || '后台已回复';
        if (action === 'recover' || action === 'fail_recover') payload.recoveryRemark = text || '后台登记挽回结果';
        (0, _decoration.decorationReviewActionApi)(row.review.id, payload).then(function () {
          _this2.$message.success('评价已更新');
          _this2.loadCurrent();
        });
      };
      if (ask) {
        this.$prompt(this.actionText(action), '点评处理').then(function (_ref) {
          var value = _ref.value;
          return exec(value);
        }).catch(function () {});
      } else {
        this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
          return exec();
        }).catch(function () {});
      }
    },
    runComplaint: function runComplaint(row, action) {
      var _this3 = this;
      var payload = {
        action: action
      };
      var exec = function exec(text) {
        if (action === 'resolve') payload.resolution = text || '后台已处理';
        (0, _decoration.decorationComplaintActionApi)(row.complaint.id, payload).then(function () {
          _this3.$message.success('投诉已更新');
          _this3.loadCurrent();
        });
      };
      if (action === 'resolve') {
        this.$prompt('处理结果', '投诉办结').then(function (_ref2) {
          var value = _ref2.value;
          return exec(value);
        }).catch(function () {});
      } else {
        this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
          return exec();
        }).catch(function () {});
      }
    }
  }
};